import isEmpty from "lodash/isEmpty";

export const getRedirectionUrl = ({
  redirectUri = '',
  prodLoginUrl = '/auth/login',
  devLoginUrl = '/login',
}) => {
  if (!isEmpty(redirectUri)) {
    return redirectUri;
  }
  return process.env.NODE_ENV === 'production'
    ? prodLoginUrl
    : devLoginUrl;
};